import React from 'react'
import { ButtonToggle } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { CircleClose } from 'app/assets/icons'
import { Icon } from 'app-v2/shared/features/icon'

type Props = {
    code: string,
    name: string,
    active?: boolean,
    marginBottom?: boolean,
    size?: number,
    handleClick?: () => void,
    handleClose?: () => void
}

const ToggleButton = (props: Props) => {
    const {
        code,
        name,
        active = false,
        marginBottom = false,
        size = 32,
        handleClick = null,
        handleClose = null
    } = props

    const { red, grey, disabled, red2, lightGrey } = colors
    return (
        <ButtonToggle
            marginBottom={marginBottom}
            onClick={handleClick}
            background={active ? red : disabled}
            color={active ? 'white' : grey}
            size={size}>
            <StyledToggleIcon
                code={code}
                size={size}
                background={active ? red2 : lightGrey}
                color={active ? 'white' : 'black'}
            />
            <Name marginLeft={!code}>{name}</Name>
            {handleClose && (
                <CloseContainer onClick={handleClose}>
                    <CircleClose size={14} background="white" color={red} />
                </CloseContainer>
            )}
        </ButtonToggle>
    )
}

const StyledToggleIcon = styled(Icon)`
    margin-right: 8px;
`

const CloseContainer = styled.i`
    margin-left: 8px;
    font-size: 0;
`

const Name = styled.div`
    ${props => props.marginLeft && 'margin-left: 15px'};
`

export { ToggleButton }
